<template>
  <div>
    <form novalidate class="md-layout" @submit.prevent="validateCategory">
      <md-card class="md-layout-item md-size-100 md-small-size-100">
        <md-card-header>
          <div class="md-title">Create new Category</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('name')">
                <label for="first-name">Name</label>
                <md-input
                  name="first-name"
                  id="first-name"
                  autocomplete="given-name"
                  v-model="form.name"
                  :disabled="sending"
                />
                <span class="md-error" v-if="!$v.form.name.required">The name is required</span>
                <span class="md-error" v-else-if="!$v.form.name.minlength">Name must be at least 3 characters.</span>
              </md-field>
            </div>
          </div>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />

        <md-card-actions>
          <md-button type="submit" class="md-primary  md-raised" :disabled="sending">Add Category</md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>
<script>
// import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  name: "newCategory",
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
    },
    sending: false,
    lastCategory: null,
    serverErrors: ""
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      }
    }
  },

  methods: {
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    clearForm() {
      this.$v.$reset();
      this.form.name = null;
    },
    saveCategory() {
      this.sending = true;
      const Category = {
        name: this.form.name,
      };
      this.$store
        .dispatch("newCategory", Category)
        .then(() => {
          this.lastCategory = `${this.form.name}`;
          this.sending = false;
          this.clearForm();
          this.$router.push("/admin/categories");
        })
        .catch(error => {
          if (error.response.status === 409) {
            this.serverErrors = "This category is already exist.";
          } else if (error.response.status === 422) {
            this.serverErrors = error.response.data.message;
          }
          this.sending = false;
        });
    },
    validateCategory() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.saveCategory();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
</style>
